<ngb-carousel *ngIf="images">
    <ng-template ngbSlide *ngFor="let image of images">
      <div class="picsum-img-wrapper">
        <img [src]="image" alt="Random slide" style="width: 100%;height: 500px;" loading="lazy">
      </div>
    </ng-template>
  </ngb-carousel>